const CACHE_TTL_MS = 5 * 60 * 1000;

const segmentCache = new Map();

function cacheKey(segment, purity, category, serviceType) {
  return `${segment}:${purity}:${category}:${serviceType}`;
}

function isStale(entry) {
  return Date.now() - entry.timestamp > CACHE_TTL_MS;
}

export function getCachedCounts(segment, purity, category, serviceType) {
  const key = cacheKey(segment, purity, category, serviceType);
  const entry = segmentCache.get(key);
  if (entry && !isStale(entry)) {
    return { ...entry.data, fromCache: true };
  }
  return null;
}

export function setCachedCounts(segment, purity, category, serviceType, data) {
  const key = cacheKey(segment, purity, category, serviceType);
  segmentCache.set(key, { data, timestamp: Date.now() });
}

export function getCachedProducts(segment, purity, category, serviceType) {
  const key = `products:${cacheKey(segment, purity, category, serviceType)}`;
  const entry = segmentCache.get(key);
  if (entry && !isStale(entry)) {
    return { ...entry.data, fromCache: true };
  }
  return null;
}

export function setCachedProducts(segment, purity, category, serviceType, data) {
  const key = `products:${cacheKey(segment, purity, category, serviceType)}`;
  segmentCache.set(key, { data, timestamp: Date.now() });
}

export function getSegmentState() {
  return segmentCache.get("__segmentState__") || {
    selectedSegment: null,
    selectedPurity: null,
    selectedCategory: null,
    history: [],
  };
}

export function setSegmentState(state) {
  segmentCache.set("__segmentState__", state);
}

export function pushNavigationState(segment, purity, category) {
  const state = getSegmentState();
  state.history.push({ segment, purity, category, timestamp: Date.now() });
  if (state.history.length > 20) state.history.shift();
  state.selectedSegment = segment;
  state.selectedPurity = purity;
  state.selectedCategory = category;
  setSegmentState(state);
}

export function clearSegmentCache() {
  for (const key of segmentCache.keys()) {
    if (key.startsWith("products:") || key.startsWith("counts:")) {
      segmentCache.delete(key);
    }
  }
}

export function getLastSelectedSegment() {
  const state = getSegmentState();
  if (state?.selectedSegment) return state.selectedSegment;
  try {
    const stored = localStorage.getItem("selectedSegment");
    if (stored) return stored;
  } catch {}
  return null;
}

export function getLastSelectedPurity() {
  const state = getSegmentState();
  if (state?.selectedPurity) return state.selectedPurity;
  try {
    const stored = localStorage.getItem("selectedPurity");
    if (stored) return stored;
  } catch {}
  return null;
}

const PURITY_BY_SEGMENT_KEY = "purityBySegment";

function readPurityBySegment() {
  try {
    const raw = localStorage.getItem(PURITY_BY_SEGMENT_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function getSegmentPurity(segment) {
  if (!segment) return null;
  return readPurityBySegment()[segment] || null;
}

export function setSegmentPurity(segment, purity) {
  if (!segment || !purity) return;
  try {
    const map = readPurityBySegment();
    map[segment] = purity;
    localStorage.setItem(PURITY_BY_SEGMENT_KEY, JSON.stringify(map));
  } catch {}
}